import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import { CustomTooltip } from '~components/Tooltip';
import { useEvent } from '~features/events/hooks/useEvent';

function SEOReportCell({ id, domain, deleted }: { id: number; domain: string; deleted: boolean }) {
  const { track } = useEvent();

  return (
    <CustomTooltip message="SEO Report Page" placement="top">
      <Link to={`/seo-report/${id}`}>
        <Button
          disabled={deleted}
          type="link"
          style={{ textDecoration: deleted ? 'line-through' : 'none' }}
          onClick={() => {
            track('Seo Report Button Clicked', { domain: domain });
          }}
        >
          Details
        </Button>
      </Link>
    </CustomTooltip>
  );
}

export default SEOReportCell;
